import { parse } from './urlHelpers';
import { isOriginInUse, isMainSearchTypeKeywords } from './search';

/**
 * URL has enough location data for distance-sorted location search (matches Topbar / loadData).
 *
 * @param {object} config - app config
 * @param {string} locationSearch - location.search from react-router
 * @returns {boolean}
 */
export function searchPageHasUsableLocation(config, locationSearch) {
  if (!config || locationSearch == null) {
    return false;
  }
  if (isMainSearchTypeKeywords(config)) {
    return true;
  }

  const queryParams = parse(locationSearch, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });
  const { address, origin, bounds } = queryParams;

  const isBrokenAddress =
    address === '[object Object]' || (typeof address === 'object' && address !== null);
  if (!address || !bounds || isBrokenAddress) {
    return false;
  }
  if (isOriginInUse(config) && !origin) {
    return false;
  }
  return true;
}

/**
 * Extract a full autocomplete-shaped value from customer-main profile service address
 * when geographic data is present (so we can sync the search URL).
 *
 * @param {object|null} currentUser
 * @returns {{ search: string, selectedPlace: { address, origin, bounds } } | null}
 */
export function getUsableServiceAddressPlaceFromUser(currentUser) {
  const profile = currentUser?.attributes?.profile;
  if (!profile) {
    return null;
  }
  const publicData = profile.publicData || {};
  if (publicData.userType !== 'customer-main') {
    return null;
  }
  const protectedData = profile.protectedData || {};
  const raw = protectedData.serviceAddress;
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const selectedPlace = raw.selectedPlace || {};
  const address =
    selectedPlace.address ||
    raw.search ||
    (typeof raw === 'string' ? raw : null);
  const origin = selectedPlace.origin;
  const bounds = selectedPlace.bounds;

  if (!address || !bounds || !origin) {
    return null;
  }

  return {
    search: raw.search || address,
    selectedPlace: {
      address,
      origin,
      bounds,
    },
  };
}
